import { cn } from '@/shared/utils'
import { DUMMY_AVATAR, onAvatarError } from '@/shared/utils'

const sizes = { xs:'w-6 h-6', sm:'w-8 h-8', md:'w-10 h-10', lg:'w-12 h-12' }

interface Props { name: string; src?: string | null; size?: 'xs'|'sm'|'md'|'lg'; online?: boolean; className?: string }

export function Avatar({ name, src, size='md', online, className }: Props) {
  return (
    <div className={cn('relative rounded-full overflow-hidden flex-shrink-0 bg-gray-100', sizes[size], className)}>
      <img
        src={src || DUMMY_AVATAR}
        alt={name}
        onError={onAvatarError}
        className="w-full h-full rounded-full object-cover"
      />
      {online && <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-400 border-2 border-white rounded-full" />}
    </div>
  )
}
